import React,{useState,useEffect} from 'react';
import { useLocation } from 'react-router-dom'
import { useSelector , useDispatch} from 'react-redux';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { connect } from "react-redux"
import Sidepanel from './Sidepanel';
import Helpers from "../Helpers/Custom";
import { login } from "../../actions/auth";
import  Config from '../Helpers/Config';

import Axios from 'axios';



function Header(props) {
   
    const location = useLocation();
    const [showSidebar, setShowSidebar] = useState(false);
    const [prefNumber, setPrefNumber] = useState(1);
    const [prefRoundFraction, setPrefRoundFraction] = useState(0);
    const [prefRoundAmt, setPrefRoundAmt] = useState(0);
    const [counts, setCounts] = useState(0);
    const [pageName , setPageName] = useState(null);

    const authDetails = useSelector(state => state?.authDetails);
    const userInfo = useSelector(state => state?.authDetails?.userInfo?.user);
    const clientConfig = useSelector(state => state?.authDetails?.userInfo?.clientConfig);
    const landingPage = authDetails?.userInfo?.setting?.landingDashboard;
     //state?.authDetails?.userInfo?.setting?.landingDashboard;
    const dispatch = useDispatch();
    

    useEffect(() => {
        
        let prefNumberStored = localStorage.getItem("prefNumber");
        let prefRoundFractionStored = localStorage.getItem("prefRoundFraction");
        let prefRoundAmtStored = localStorage.getItem("prefRoundAmt");
       

        setPrefNumber(prefNumberStored);
        setPrefRoundFraction(prefRoundFractionStored);
        setPrefRoundAmt(prefRoundAmtStored);

   
        loginFunction();
        fetchCount()
        setInterval(fetchCount, 50000);
       
    }, [])
    

    useEffect(() => {
        // let lclPageName = location.state.pageName;
        // setPageName(lclPageName)
    }, [props])

  

    const loginFunction = async ()=>{
        await login(dispatch);
    }

    const fetchCount = ()=>{

       Axios.get(Config.api("api/notifications/unread/count"))
            .then( (response) => {
                var dataset  = response.data;
                setCounts(dataset);
            })
            .catch((err) => {
            
            });
    }
   
    const toggle =(e)=>{
        e.stopPropagation()
        setShowSidebar(!showSidebar)
    }

    const setParent = (status)=>{
        setShowSidebar(status)
    }

    const check = (e)=>{
        e.stopPropagation();
    }

    const changePrefNumber = (e)=>{
        var option = e.target.value;
        localStorage.setItem("prefNumber", option);
        var amountDivision =  e.target.options[e.currentTarget.selectedIndex].dataset.amountdivision;
        var amountSymbol = e.target.options[e.currentTarget.selectedIndex].dataset.amountsymbol;

        localStorage.setItem("amountDivision", amountDivision);
        localStorage.setItem("amountSymbol", amountSymbol);
        updateClientPref("amountDivision",amountDivision,false);
        updateClientPref("amountSymbol",amountSymbol,true);
        
    }

    const changePrefRoundFraction = (e)=>{
        var option = e.target.value;
		localStorage.setItem("prefRoundFraction", option);
		var prefRoundAmt = e.target.value;
		updateClientPref("prefRoundFraction",prefRoundAmt,true);
    }

    const changePrefRoundAmt = (e)=>{
        var option = e.target.value;
        localStorage.setItem("prefRoundAmt", option);
        updateClientPref("prefRoundAmt",option,true);
    }

    const updateClientPref = (key,value,reload)=>{
        if(reload == undefined)
            reload = true;
        if(reload){
            window.location.reload();
        }
    }

  
    return (
        <React.Fragment>
            <Navbar bg="white" variant="light" className="topMenu">
                <Container fluid>
                <Navbar.Text className="mr-10 pointer" onClick={toggle}>
                    <i className="fa fa-bars"></i>
                </Navbar.Text>
               {
                !Helpers.isMobile() &&
                <Navbar.Brand className="ms-3" id="header">
                    <a href={"/"+landingPage} className="homeLink"> <img src={"https://assets.investera.com/investera-client-configs/clients/"+Config.provider+"/logo.png"} width="100" title="" /></a>
                </Navbar.Brand>
                }
                <Navbar.Text className="pageTitle me-auto">
                   {Helpers.isEmpty(location?.state?.pageName) ? Helpers.getPageName() : location?.state?.pageName}
                </Navbar.Text>
                <Nav className="text-default">
                    {/*<Nav.Link href={clientConfig?.website} target="_blank">{clientConfig?.name}</Nav.Link>*/}
                    <NavDropdown title="Preferences" id="preferences-dropdown">
                        <NavDropdown.Item onClick={check}>
                            <div className="preferanceDiv">
                                <div>Number Format</div>
                                <div>
                                    <select id="prefNumber" className="form-control" onChange={changePrefNumber}>
                                        <option value="1000000" data-amountDivision="1000000"
                                                data-amountSymbol="M" selected={"1000000" == prefNumber}>Millions</option>
                                        <option value="1000" data-amountDivision="1000"  selected={"1000" == prefNumber}
                                                data-amountSymbol="K">Thousands</option>
                                        <option value="1" data-amountDivision="1" data-amountSymbol="" selected={"1" == prefNumber}>Full
                                            Number</option>
                                    </select>
                                </div>
                                <br/>
                                <div>Round Fraction</div>
                                <div>
                                    <select id="prefRoundFraction" className="form-control" onChange={changePrefRoundFraction}>
                                        <option value="null">Please Select</option>
                                        {
                                            [0,1,2,3,4,5,6].map((option,i)=>(
                                                <option key={i} value={option} selected={option == prefRoundFraction}>{option}</option>
                                            ))
                                        }
                                        
                                    </select>
                                </div>
                                <br/>
                                <div>Round Amount</div>
                                <div>
                                    <select id="prefRoundAmt" className="form-control" onChange={changePrefRoundAmt}>
                                        <option value="null">Please Select</option>
                                        {
                                            [0,1,2,3,4,5,6].map((option,i)=>(
                                                    <option key={i} value={option}  selected={option == prefRoundAmt}>{option}</option>
                                            ))
                                        }
                                    </select>
                                </div>
							</div>
                        </NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="/notifications">
                        <i className="fas fa-bell"></i>
                        <span className="badge text-white">{counts}</span>
                    </Nav.Link>
                </Nav>
                </Container>
            </Navbar>
            <Sidepanel showSidebar={showSidebar} setParent={setParent} userInfo={userInfo} landingPage={landingPage}/>
        </React.Fragment>
    )
}

export default connect()(Header);
